import http from 'helpers/APIHelper';
import { map } from 'rxjs/operators';
import { httpStatusEnum } from 'appconstants';
import { getSessionByKey } from 'helpers';
import { suffixPending, suffixFulfilled, suffixRejected } from 'actions';


export const PARTICIPATION_ACTIONS = {
  GET_PARTICIPATION: '@protocol/participation/getparticipation',
  GET_CHAMPIONS: '@protocol/participation/getchampions',
  GET_COUNTRIES: '@protocol/participation/getcountry'
};

export const getParticipation = (token, loggerInfo, id, postBody = {
  sort: [{
    field: 'orgType',
    value: 'asc'
  }, {
    field: 'participantGroup',
    value: 'desc'
  }]
}) => dispatch => {
  dispatch({
    type: PARTICIPATION_ACTIONS.GET_PARTICIPATION + suffixPending
  });
  http
    .postWithToken(
      `protocol-data-service/${
        getSessionByKey('prt_url_ver')
      }/protocols/number/${id}/participants`,
      token,
      loggerInfo,
      JSON.stringify(postBody)
    )
    .subscribe(
      resp => {
        dispatch({
          type: PARTICIPATION_ACTIONS.GET_PARTICIPATION + suffixFulfilled,
          payload: resp.response
        });
      },
      error => {
        dispatch({
          type: PARTICIPATION_ACTIONS.GET_PARTICIPATION + suffixRejected,
          payload: error
        });
      }
    );
};

export const saveParticipation = (token, loggerInfo, id, postBody) => (
  dispatch,
  getState
) => http
  .putWithToken(
    `protocol-data-service/${
      getSessionByKey('prt_url_ver')
    }/protocols/id/${id}/participants`,
    token,
    loggerInfo,
    JSON.stringify(postBody)
  ).pipe(
    map(resp => {
      if (resp.status === httpStatusEnum.SUCCESS) {
        dispatch(getParticipation(
          token,
          loggerInfo,
          getState().prtDetails.prtInfo.protocolNumber
        ));
      }
      return resp;
    })
  );


export const saveRestriction = (token, loggerInfo, id, pspId, postBody) => (
  dispatch,
  getState
) => http
  .putWithToken(
    `protocol-data-service/${
      getSessionByKey('prt_url_ver')
    }/protocols/number/${id}/participants/${pspId}/restriction`,
    token,
    loggerInfo,
    JSON.stringify(postBody)
  )
  .pipe(
    map(resp => {
      if (resp.status === httpStatusEnum.SUCCESS) {
        dispatch(getParticipation(
          token,
          loggerInfo,
          getState().prtDetails.prtInfo.protocolNumber
        ));
      }
      return resp;
    })
  );

export const getChampions = (token, loggerInfo, id) => dispatch => {
  dispatch({
    type: PARTICIPATION_ACTIONS.GET_CHAMPIONS + suffixPending
  });
  http
    .postWithToken(
      `protocol-data-service/${
        getSessionByKey('prt_url_ver')
      }/protocols/number/${id}/champions`,
      token,
      loggerInfo
    )
    .subscribe(
      resp => {
        dispatch({
          type: PARTICIPATION_ACTIONS.GET_CHAMPIONS + suffixFulfilled,
          payload: resp.response
        });
      },
      error => {
        dispatch({
          type: PARTICIPATION_ACTIONS.GET_CHAMPIONS + suffixRejected,
          payload: error
        });
      }
    );
};

export const getCountry = (token, loggerInfo, id) => dispatch => {
  dispatch({
    type: PARTICIPATION_ACTIONS.GET_COUNTRIES + suffixPending
  });
  http
    .postWithToken(
      `protocol-data-service/${
        getSessionByKey('prt_url_ver')
      }/protocols/number/${id}/countryparticipants`,
      token,
      loggerInfo
    )
    .subscribe(
      resp => {
        dispatch({
          type: PARTICIPATION_ACTIONS.GET_COUNTRIES + suffixFulfilled,
          payload: resp.response
        });
      },
      error => {
        dispatch({
          type: PARTICIPATION_ACTIONS.GET_COUNTRIES + suffixRejected,
          payload: error
        });
      }
    );
};

export const testSiteRegistration = (
  token,
  loggerInfo,
  id,
  site
) => dispatch => http
  .getWithToken(
    `protocol-data-service/${
      getSessionByKey('prt_url_ver')
    }/protocols/number/${id}/site/${site}/testparticipation`,
    token,
    loggerInfo
  )
  .pipe(
    map(resp => resp)
  );

export const saveParticipantCountries = (token, loggerInfo, id, postBody) => (
  dispatch,
  getState
) => http
  .putWithToken(
    `protocol-data-service/${
      getSessionByKey('prt_url_ver')
    }/protocols/id/${id}/countryparticipant`,
    token,
    loggerInfo,
    JSON.stringify(postBody)
  )
  .pipe(
    map(resp => {
      if (resp.status === httpStatusEnum.SUCCESS) {
        dispatch(getCountry(
          token,
          loggerInfo,
          getState().prtDetails.prtInfo.protocolNumber
        ));
      }
      return resp;
    })
  );

export const setParticipantsSync = (token, loggerInfo, number) => dispatch => http
  .putWithToken(
    `protocol-data-service/${
      getSessionByKey('prt_url_ver')
    }/protocols/number/${number}/participants/sync`,
    token,
    loggerInfo
  )
  .pipe(
    map(resp => resp)
  );
